import { useDeviceStore } from "@/storeModules/devices/DeviceStore";
import { DXAlarm, DXIssue } from "@/types";

export type NavigationMenu = NavigationToplevelItem[];

export type NavigationToplevelItem = NTIBasic | NTIDevices | NTICustomers | NTINested;

export abstract class NTIBase {
  constructor(
    public i18nkey: string,
    public logo: string,
    public children: SecondLevelNavigationItem[],
    public navigationPathName: string
  ) { }
  public abstract readonly type: string;
}

export type SecondLevelNavigationItem = {
  i18nkey: string;
  targetRouteName: string;
};

export class NTIBasic extends NTIBase {
  constructor(i18nkey: string, logo: string, linkPathName: string) {
    super(i18nkey, logo, [], linkPathName);
  }
  public readonly type = "BASIC";
}

export class NTIDevices extends NTIBase {
  constructor(
    public devicesByTags: ReturnType<typeof useDeviceStore>["getDevicesGroupByTags"],
    public alarms: DXAlarm[],
    public issues: {
      [key: number]: DXIssue[];
    }
  ) {
    super("navi.item_devices", "hard-drive", [], "Device List");
  }
  public readonly type = "DEVICE";
}

// TODO: Update it after the endpoint is ready and move it to types.ts
export type NavigationCustomer = {
  id: string;
  name: string;
};

export class NTICustomers extends NTIBase {
  constructor(
    public customers: NavigationCustomer[],
    public alarms: DXAlarm[],
    public issues: {
      [key: number]: DXIssue[];
    }
  ) {
    super("navi.item_customer_management", "building", [], "MultiTenancyOnboarding");
  }
  public readonly type = "CUSTOMER";
}

export class NTINested extends NTIBase {
  constructor(i18nkey: string, logo: string, children: SecondLevelNavigationItem[], linkPathName: string) {
    super(i18nkey, logo, children, linkPathName);
  }
  public readonly type = "NESTED";
}
